import axios from "axios";
import { INSPECTION_URL } from "../Helper";

export const getAutosaveSetting = () => {
  return axios.get(`${INSPECTION_URL}user/settings/autosave`);
};

export const updateAutosaveSetting = (data) => {
  return axios.post(`${INSPECTION_URL}user/settings/autosave`, data);
};
